module.exports = __webpack_public_path__ + "static/cabinet-8acea9f9b9dbb87aa88a5bf19a8221f4.jpg";